import React from 'react';

const Icons = () => (
  <>
    <svg
      style={{ position: 'absolute', height: 0, width: 0 }}
      width="0"
      height="0"
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      xmlnsXlink="https://www.w3.org/1999/xlink"
    >
      <defs>
        <symbol id="icon-facebook" viewBox="0 0 542 1024">
          <title>facebook</title>
          <path
            className="path1"
            d="M350.871 1017.615v-464.173h159.322l23.974-180.887h-183.296v-115.531c0-52.405 14.878-88.064 91.738-88.064h98.003v-161.912c-16.986-2.108-75.113-7.048-142.758-7.048-141.372 0-238.11 84.329-238.11 239.134v133.421h-159.744v180.887h159.804v464.173h191.066z"
          />
        </symbol>
        <symbol id="icon-google" viewBox="0 0 683 1024">
          <title>google</title>
          <path
            className="path1"
            d="M355.669 0c-185.287 0-285.582 117.305-285.582 248.263 0 99.669 71.509 212.196 218.852 212.196h37.205s-10.126 24.633-10.24 48.469c0 35.1 12.686 54.841 39.481 85.22-253.554 15.474-355.442 117.76-355.442 227.556 0 96.313 92.16 191.033 285.867 191.033 229.262 0 348.046-127.26 348.046-252.245 0-88.064-43.804-136.306-155.022-219.591-32.654-25.372-38.969-41.529-38.969-60.587 0-27.193 16.27-45.227 22.187-52.053 10.581-11.093 28.786-23.78 35.612-29.81 37.262-31.63 89.998-78.507 89.998-171.804 0-64.171-26.738-119.296-87.381-170.951h74.297l55.637-55.751h-274.489zM304.469 41.7c33.678 0 61.781 11.947 91.42 36.523 32.825 29.582 85.333 109.227 85.333 207.815 0 106.382-82.66 135.509-127.431 135.509-21.788 0-48.071-6.144-70.258-21.333-49.323-31.972-98.304-117.191-98.304-218.453 0-91.42 54.5-140.060 119.239-140.060zM377.856 634.482c14.222 0 24.348 1.138 24.348 1.138s33.337 23.893 56.661 41.7c54.215 42.894 88.064 75.662 88.064 134.030 0 80.213-74.524 143.246-195.129 143.246-132.324 0-233.472-61.668-233.472-162.304 0-83.342 69.404-155.079 259.584-157.753z"
          />
        </symbol>
        <symbol id="icon-twitter" viewBox="0 0 1243 1024">
          <title>twitter</title>
          <path
            className="path1"
            d="M1057.646 152.649c50.834-30.135 89.966-77.897 108.251-134.802-47.543 27.794-100.206 48.274-156.233 59.099-44.91-47.323-108.763-76.946-179.493-76.946-136.046 0-246.126 109.129-246.126 243.712 0 19.017 2.194 37.742 6.363 55.589-204.361-10.386-385.609-107.301-507.026-254.683-20.992 35.986-33.134 77.824-33.134 122.514 0 84.553 43.447 159.159 109.422 202.898-40.229-1.463-78.263-12.434-111.397-30.574-0.146 1.024-0.146 2.048-0.146 3.072 0 118.053 84.846 216.503 197.339 238.958-20.626 5.632-42.423 8.631-64.805 8.631-15.872 0-31.232-1.463-46.299-4.389 31.305 96.841 122.149 167.278 229.815 169.253-84.261 65.39-190.318 104.448-305.664 104.448-19.749 0-39.497-1.243-58.661-3.511 108.837 69.193 238.153 109.495 377.051 109.495 452.462 0 699.977-371.419 699.977-693.541 0-10.533-0.293-21.065-0.731-31.451 48.055-34.377 89.746-77.312 122.734-126.245-44.105 19.383-91.575 32.549-141.312 38.4z"
          />
        </symbol>
        <symbol id="icon-analyze" viewBox="0 0 1280 1024">
          <title>analyze</title>
          <path
            className="path1"
            d="M242.198 192h192v576h-192v-576zM562.198 320h192v448h-192v-448zM882.198 0h192v768h-192v-768zM1266.198 896v128h-1216v-128h1216z"
          />
        </symbol>
        <symbol id="icon-search" viewBox="0 0 1024 1024">
          <title>search</title>
          <path
            className="path1"
            d="M973.802 859.239l-108.707 108.060-261.586-264.339c-61.128 41.074-134.713 65.040-213.895 65.040-212.077 0-384-171.923-384-384s171.923-384 384-384c212.077 0 384 171.923 384 384 0 79.257-24.012 152.906-65.157 214.070l265.345 261.169zM389.614 640c141.385 0 256-114.615 256-256s-114.615-256-256-256c-141.385 0-256 114.615-256 256s114.615 256 256 256z"
          />
        </symbol>
        <symbol id="icon-settings" viewBox="0 0 658 1024">
          <title>opacity</title>
          <path
            className="path1"
            d="M329.143 1024c181.781 0 329.143-147.362 329.143-329.143s-188.082-322.494-329.143-694.857c-141.061 372.364-329.143 513.077-329.143 694.857s147.362 329.143 329.143 329.143z"
          />
        </symbol>
        <symbol id="icon-share" viewBox="0 0 1088 1024">
          <title>share</title>
          <path
            className="path1"
            d="M29.802 512c0 106.24 85.76 192 192 192 51.84 0 99.2-20.48 133.12-53.76l316.16 158.080c-0.64 7.68-1.28 15.36-1.28 23.68 0 106.24 85.76 192 192 192s192-85.76 192-192c0-106.24-85.76-192-192-192-51.84 0-98.56 20.48-133.12 53.76l-316.8-158.080c1.28-7.68 1.92-15.36 1.92-23.68s-0.64-16-1.92-23.68l316.8-158.080c33.92 33.28 81.28 53.76 133.12 53.76 106.24 0 192-85.76 192-192s-85.76-192-192-192c-106.24 0-192 85.76-192 192 0 8.32 0.64 16 1.28 23.68l-316.16 158.080c-33.92-33.28-81.28-53.76-133.12-53.76-106.24 0-192 85.76-192 192z"
          />
        </symbol>
        <symbol id="icon-visibilityoff" viewBox="0 0 1024 1024">
          <title>visibility off</title>
          <path
            className="path1"
            d="M843.485 114.318l-723.284 734.221 60.315 61.145 723.284-734.221-60.315-61.145zM726.085 443.235c7.539 21.625 11.683 44.657 11.683 68.765 0 119.967-101.076 217.234-225.769 217.234-20.795 0-40.762-2.817-59.901-7.87l-61.557 62.469c39.105 7.954 79.786 12.179 121.459 12.179 217.649 0 406.961-114.913 503.73-284.094-42.254-73.903-102.32-137.366-174.649-185.502l-114.996 116.737zM286.231 512c0-119.967 101.076-217.234 225.769-217.234 20.795 0 40.762 2.817 59.901 7.87l61.557-62.469c-39.105-8.036-79.786-12.179-121.459-12.179-217.649 0-406.961 114.913-503.73 284.094 42.254 73.903 102.32 137.366 174.649 185.502l114.996-116.737c-7.539-21.625-11.683-44.657-11.683-68.765zM475.629 400.318c-39.935 12.096-71.003 43.414-81.442 82.685l81.442-82.685zM548.371 623.682c39.935-12.096 71.003-43.33 81.442-82.685l-81.442 82.685z"
          />
        </symbol>
        <symbol id="icon-visibilityon" viewBox="0 0 1024 1024">
          <title>visibility on</title>
          <path
            className="path1"
            d="M286.231 517.489c0-111.931 101.076-202.736 225.769-202.736s225.769 90.804 225.769 202.736c0 111.931-101.076 202.736-225.769 202.736s-225.769-90.804-225.769-202.736zM1015.73 517.489c-96.769-157.913-286.083-318.145-503.73-318.145s-406.961 160.234-503.73 318.145c96.769 157.913 286.083 318.145 503.73 318.145s406.961-160.234 503.73-318.145zM390.377 517.489c0 60.315 54.432 109.114 121.623 109.114s121.623-48.881 121.623-109.114c0-60.315-54.432-109.114-121.623-109.114s-121.623 48.881-121.623 109.114z"
          />
        </symbol>
        <symbol id="icon-drag" viewBox="0 0 640 1024">
          <title>draggable</title>
          <path
            className="path1"
            d="M0 768h256v256h-256v-256zM384 768h256v256h-256v-256zM0 384h256v256h-256v-256zM384 384h256v256h-256v-256zM0 0h256v256h-256v-256zM384 0h256v256h-256v-256z"
          />
        </symbol>
        <symbol id="icon-back-arrow" viewBox="0 0 745 1024">
          <title>back arrow</title>
          <path
            className="path1"
            d="M537.879 43.753l-487.61 487.796 65.908 65.815 421.702 421.702 131.631-131.91-421.702-421.702v131.724l421.702-421.702-131.631-131.724z"
          />
        </symbol>
        <symbol id="icon-check" viewBox="0 0 1303 1024">
          <title>check</title>
          <path
            className="path1"
            d="M27.276 531.27l494.499 494.499 714.007-873.844-144.291-117.853-648.844 794.065 137.961-6.889-421.702-421.702-131.631 131.724z"
          />
        </symbol>
        <symbol id="icon-next-arrow" viewBox="0 0 585 1024">
          <title>next arrow</title>
          <path
            className="path1"
            d="M52.175 1018.344l506.344-506.344-17.213-17.262-488.984-489.082-34.572 34.523 489.082 489.082v-34.523l-489.131 489.082 34.475 34.523z"
          />
        </symbol>
        <symbol id="icon-downloads" viewBox="0 0 939 1024">
          <title>downloads</title>
          <path
            className="path1"
            d="M853.333 938.667h-768v-298.667h-85.333v384h938.667v-384h-85.333v298.667z"
          />
          <path className="path2" d="M426.667 0h85.333v597.333h-85.333v-597.333z" />
          <path
            className="path3"
            d="M119.584 313.147l70.556-70.556 282.225 282.225-70.556 70.556-282.225-282.225zM754.591 242.591l70.556 70.556-352.781 352.781-70.556-70.556 352.781-352.781z"
          />
        </symbol>
        <symbol id="icon-info" viewBox="0 0 1024 1024">
          <title>info</title>
          <path
            className="path1"
            d="M512 1024c-282.77 0-512-229.23-512-512s229.23-512 512-512c282.77 0 512 229.23 512 512s-229.23 512-512 512zM512 950.857c242.374 0 438.857-196.483 438.857-438.857s-196.483-438.857-438.857-438.857c-242.374 0-438.857 196.483-438.857 438.857s196.483 438.857 438.857 438.857z"
          />
          <path className="path2" d="M438.857 438.857h146.286v365.714h-146.286v-365.714z" />
          <path className="path3" d="M438.857 219.429h146.286v146.286h-146.286v-146.286z" />
        </symbol>
        <symbol id="icon-remove" viewBox="0 0 1024 1024">
          <title>remove</title>
          <path
            className="path1"
            d="M512 0c-282.77 0-512 229.23-512 512s229.23 512 512 512 512-229.23 512-512-229.23-512-512-512zM512 928c-229.75 0-416-186.25-416-416s186.25-416 416-416 416 186.25 416 416-186.25 416-416 416z"
          />
          <path
            className="path2"
            d="M672 256l-160 160-160-160-96 96 160 160-160 160 96 96 160-160 160 160 96-96-160-160 160-160z"
          />
        </symbol>

        <symbol
          id="icon-zoom-pan"
          width="11"
          height="11"
          viewBox="0 0 11 11"
          xmlns="https://www.w3.org/2000/svg"
        >
          <title>zoom pan</title>
          <g>
            <path d="M5.62 4.672l.708.707-4.95 4.948-.706-.707z" />
            <path d="M.482 4.722h1.17V9.4H.48V4.72zM6.328 9.4v1.168H.482v-1.17h5.846z" />
            <g>
              <path d="M5.515 6.192l-.707-.707 4.95-4.95.706.708z" />
              <path d="M10.654 6.142h-1.17V1.465h1.17v4.677zM4.808 1.465V.295h5.846v1.17H4.808z" />
            </g>
          </g>
        </symbol>

        {/* Copypasted only needed from Vizzuality-components to prevent overrighting similar icons */}
        <symbol id="icon-plus" viewBox="0 0 32 32">
          <title>plus</title>
          <path d="M13.865 5v8.8h-8.865v4.4h8.865v8.8h4.271v-8.8h8.865v-4.4h-8.865v-8.8z" />
        </symbol>

        <symbol id="icon-minus" viewBox="0 0 32 32">
          <title>minus</title>
          <path d="M5.5 17.909h20.894v-3.818h-20.894z" />
        </symbol>

        <symbol id="icon-crop" viewBox="0 0 22 22">
          <title>crop</title>
          <path d="M17,15 L19,15 L19,7 C19,5.9 18.1,5 17,5 L9,5 L9,7 L17,7 L17,15 Z M7,17 L7,1 L5,1 L5,5 L1,5 L1,7 L5,7 L5,17 C5,18.1 5.9,19 7,19 L17,19 L17,23 L19,23 L19,19 L23,19 L23,17 L7,17 Z" />
        </symbol>

        <symbol id="icon-compare" viewBox="0 0 24 24">
          <title>compare layers</title>
          <path d="M10 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H10V23H12V1H10V3ZM10 19H4V5H10V19Z" />
          <path d="M22 5C22 3.9 21.1 3 20 3H14V5H20V19H14V21H20C21.1 21 22 20.1 22 19V5Z" />
          <path d="M18 9H14V11H18V9Z" />
          <path d="M18 13H14V15H18V13Z" />
          <path d="M8 9H6V11H8V9Z" />
          <path d="M8 13H6V15H8V13Z" />
        </symbol>

        <symbol id="icon-arrow-right" viewBox="0 0 6 11">
          <title>arrow</title>
          <path d="M0.469727 10.0302L4.99988 5.5L0.469727 0.969849" fill="none" />
        </symbol>

        <symbol id="icon-calendar" viewBox="0 0 13 14">
          <title>calendar</title>
          <path d="M3.17678 3.59172H3.36277C3.64542 3.59172 3.87454 3.36252 3.87454 3.07995V1.66768V1.13943C3.87454 0.856857 3.64542 0.627686 3.36277 0.627686H3.17678C2.89416 0.627686 2.66504 0.856857 2.66504 1.13943V1.66771V3.07995C2.66504 3.36252 2.89416 3.59172 3.17678 3.59172Z" />
          <path d="M9.74092 3.57902H9.92691C10.2095 3.57902 10.4387 3.34985 10.4387 3.06725V1.53363V1.12671C10.4387 0.844162 10.2095 0.61499 9.92691 0.61499H9.74092C9.45824 0.61499 9.22913 0.844162 9.22913 1.12671V1.53363V3.06723C9.22918 3.34985 9.4583 3.57902 9.74092 3.57902Z" />
          <path d="M12.168 1.66772H10.8546V3.20132C10.8546 3.7129 10.4384 3.99507 9.92692 3.99507H9.74093C9.22935 3.99507 8.81318 3.57886 8.81318 3.06728V1.66772H4.29051V3.07996C4.29051 3.59154 3.87434 4.00775 3.36276 4.00775H3.17677C2.66522 4.00775 2.24904 3.59154 2.24904 3.07996V1.66772H0.831977C0.373232 1.66772 0 2.04096 0 2.49973V12.5531C0 13.0119 0.373232 13.3851 0.831977 13.3851H12.168C12.6268 13.3851 13 13.0119 13 12.5531V2.49973C13.0001 2.04098 12.6268 1.66772 12.168 1.66772ZM12.168 12.5531H0.832004L0.831977 4.96105H12.1682L12.1686 12.5531C12.1686 12.5531 12.1684 12.5531 12.168 12.5531Z" />
          <path d="M6.92949 7.50759H8.42336C8.48257 7.50759 8.53058 7.45958 8.53058 7.40036V6.1068C8.53058 6.04758 8.48257 5.99957 8.42336 5.99957H6.92949C6.87028 5.99957 6.82227 6.04758 6.82227 6.1068V7.40036C6.82227 7.45958 6.87028 7.50759 6.92949 7.50759Z" />
          <path d="M9.36748 7.50759H10.8613C10.9206 7.50759 10.9686 7.45958 10.9686 7.40036V6.1068C10.9686 6.04758 10.9206 5.99957 10.8613 5.99957H9.36748C9.30826 5.99957 9.26025 6.04758 9.26025 6.1068V7.40036C9.26025 7.45958 9.30826 7.50759 9.36748 7.50759Z" />
          <path d="M2.05364 9.62529H3.54748C3.60669 9.62529 3.6547 9.57728 3.6547 9.51807V8.22448C3.6547 8.16526 3.60669 8.11725 3.54748 8.11725H2.05364C1.99442 8.11725 1.94641 8.16526 1.94641 8.22448V9.51807C1.94641 9.57728 1.99442 9.62529 2.05364 9.62529Z" />
          <path d="M4.49163 9.62529H5.98546C6.04468 9.62529 6.09269 9.57728 6.09269 9.51807V8.22448C6.09269 8.16526 6.04468 8.11725 5.98546 8.11725H4.49163C4.43241 8.11725 4.3844 8.16526 4.3844 8.22448V9.51807C4.3844 9.57728 4.43241 9.62529 4.49163 9.62529Z" />
          <path d="M6.92962 9.62529H8.42345C8.48267 9.62529 8.53068 9.57728 8.53068 9.51807V8.22448C8.53068 8.16526 8.48267 8.11725 8.42345 8.11725H6.92962C6.8704 8.11725 6.82239 8.16526 6.82239 8.22448V9.51807C6.82239 9.57728 6.8704 9.62529 6.92962 9.62529Z" />
          <path d="M9.36748 9.62529H10.8613C10.9206 9.62529 10.9686 9.57728 10.9686 9.51807V8.22448C10.9686 8.16526 10.9206 8.11725 10.8613 8.11725H9.36748C9.30826 8.11725 9.26025 8.16526 9.26025 8.22448V9.51807C9.26025 9.57728 9.30826 9.62529 9.36748 9.62529Z" />
          <path d="M3.54745 10.235H2.05364C1.99442 10.235 1.94641 10.2831 1.94641 10.3423V11.6359C1.94641 11.6951 1.99442 11.7431 2.05364 11.7431H3.54748C3.60669 11.7431 3.6547 11.6951 3.6547 11.6359V10.3423C3.65468 10.2831 3.60667 10.235 3.54745 10.235Z" />
          <path d="M5.98546 10.235H4.49163C4.43241 10.235 4.3844 10.2831 4.3844 10.3423V11.6359C4.3844 11.6951 4.43241 11.7431 4.49163 11.7431H5.98546C6.04468 11.7431 6.09269 11.6951 6.09269 11.6359V10.3423C6.09269 10.2831 6.04468 10.235 5.98546 10.235Z" />
          <path d="M8.42348 10.235H6.92962C6.8704 10.235 6.82239 10.2831 6.82239 10.3423V11.6359C6.82239 11.6951 6.8704 11.7431 6.92962 11.7431H8.42348C8.4827 11.7431 8.53071 11.6951 8.53071 11.6359V10.3423C8.53071 10.2831 8.4827 10.235 8.42348 10.235Z" />
          <path d="M10.8613 10.235H9.36748C9.30826 10.235 9.26025 10.2831 9.26025 10.3423V11.6359C9.26025 11.6951 9.30826 11.7431 9.36748 11.7431H10.8613C10.9206 11.7431 10.9686 11.6951 10.9686 11.6359V10.3423C10.9686 10.2831 10.9206 10.235 10.8613 10.235Z" />
        </symbol>
      </defs>
    </svg>
  </>
);

export default Icons;
